
import { Vue, Component, Prop } from "vue-property-decorator";
import RouteParams from "@/entities/RouteParams";
import RouteNames from "@/entities/RouteNames";
import InformationWrapper from "@/components/inforationCards/InformationWrapper.vue";
import FormattedDescription from "@/components/common/FormattedDescription.vue";
import Chip from "@/components/filters/Chip.vue";
import InformationCard from "@/components/inforationCards/InformationCard.vue";
import { Project, User } from "@/generated/graphql";
import { getSkillsForChips } from "@/helpers/cardInfoHelperFunctions/chipDataHelpers";
import GET_PROJECT_CONTRACTORS from "@/apollo/projects/GetProjectResources.gql";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import { NO_INFORMATION } from "@/data/placeholders";
import Roles from "@/entities/Roles";
import GET_PROJECT from "@/apollo/projects/GetProjectManagement.gql";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMoreCustom.vue";
import ItemChipsData from "@/entities/ItemChipsData";
import S3Image from "@/components/common/s3-image.vue";
import { getTagsForChips } from "@/helpers/cardInfoHelperFunctions/chipDataHelpers";

@Component({
  components: {
    InformationWrapper,
    InformationCard,
    S3Image,
    FormattedDescription,
    ItemChipsWithMore,
    CardBodyItem,
    Chip,
    EmptyListPlaceholder,
  },
  apollo: {
    project: {
      query: GET_PROJECT,
      variables() {
        return {
          id: this.$route.params.id,
        };
      },
      update(data: any): any {
        this.project = data.project_by_pk;
        return data.project_by_pk;
      },
    },
    projectContarctors: {
      query: GET_PROJECT_CONTRACTORS,
      variables() {
        return {
          projectId: this.$route.params.id,
        };
      },
      update(data: any): any {
        this.projectRes = data.contractor;
        return data.contractor;
      },
    },
  },
})
export default class Details extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  placeholder: string = NO_INFORMATION;
  project?: Project = null;
  projectRes?: null;

  get budget(): string {
    if (this.project) {
      const { min_budget, max_budget } = this.project!;

      if (min_budget && max_budget) {
        return ` $${min_budget} - $${max_budget}`;
      }

      if (min_budget) {
        return ` $${min_budget}`;
      }

      if (max_budget) {
        return `$${max_budget}`;
      }
    }
  }
  get allowClokcin() {
    if (this.project?.enable_visit_based_clock_ins === true) {
      return "Turned on.";
    } else if (this.project?.enable_visit_based_clock_ins === false) {
      return "urned off";
    }
    return "N/A";
  }
  get specialInstructions(): string {
    return this.project?.special_instructions;
  }

  getContactorLink(res) {
    return {
      name: RouteNames.CONTRACTOR_PUBLIC_PAGE,
      params: { id: res.user.id },
    };
  }
  get skillsExist(): boolean {
    return this.project.project_skills.length > 0;
  }

  get isAdmin(): boolean {
    return (
      this.currentUser.role === Roles.ADMIN ||
      this.currentUser.role === Roles.MANAGER
    );
  }

  get defaultInitialsClasses(): string {
    return "inline-flex h-6 w-6 rounded-full items-center justify-center";
  }

  get defaultImageClasses() {
    return "text-storm-gray text-sm font-medium rounded-full border border-gray-300 bg-white w-8 h-8 mr-2";
  }
  get getAvatrClass() {
    return "chipHeight flex-shrink-0 circleWidth rounded-full bg-primary-500 flex items-center text-xs justify-center text-white";
  }

  get projectResource() {
    return this.projectRes;
  }
  get projectSkills(): ItemChipsData[] {
    const skills = this.project.project_skills.map(
      (userSkill) => userSkill.skill
    );
    return getSkillsForChips(skills);
  }
  get projectTags(): ItemChipsData[] {
    const tags = this.project.project_skills.map(
      (userSkill) => userSkill.skill
    );
    const uniqueTags = Array.from(
    new Map(tags.map((tag) => [tag.id, tag])).values()
  );
    return getTagsForChips(uniqueTags);
  }
}
